import classLoader from '../../vively/scripts/utils/class-loader';
import SidebarNav from '../../minisite/scripts/sidebar-nav.js';
import $ from 'jquery';

const Minisite = () => {
  // Activating sidebar
  classLoader({ _class: SidebarNav });

  // Hot-fix fixed "send me details"
  const $ctaContainer = $('.minisite-cta-container');
  const $form = $('.minisite__form');

  if ($ctaContainer.length + $form.length >= 2) {
    const $window = $(window);
    const $body = $('body');
    const handle = () => {
      const viewportTop = $window.scrollTop();
      const viewportBottom = viewportTop + $window.height() - ($ctaContainer.outerHeight() * 2);

      const formTop = $form.offset().top;
      const formBottom = formTop + $form.height();

      if (formBottom <= viewportBottom || formTop >= viewportBottom) {
        $ctaContainer.removeClass('hidden');
      } else {
        $ctaContainer.addClass('hidden');
      }
    };

    ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $window).scroll(handle);
    $window.resize(handle);
    handle();
  }
};

export default Minisite;



// WEBPACK FOOTER //
// ./minisite/scripts/main.js